import React, { useEffect, useState } from "react"
import { Grid, Col, Row, Button, FormControl, FormGroup, Glyphicon, InputGroup } from "react-bootstrap"
import LoadingAnimation from "../../../../reuseable-components/LoadingAnimation"
import PaginationButtons from "../../../../reuseable-components/PaginationButtons"
import axios from "axios"
import swal from 'sweetalert'
import getServerURL from "../../../../functions/getServerURL"
import { handleErrorFetchingData } from "../../../../functions/errorHandling"
import FunctionalGroupList from "./FunctionalGroupList"
import CreateEditFunctionalGroupModal from "./CreateEditFunctionalGroupModal"


export default function FunctionalGroupContainer() {
  // STATE
  const [functionalGroups, setFunctionalGroups] = useState([])
  const [fetchingFunctionalGroups, setFetchingFunctionalGroups] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const [searchTerm, setSearchTerm] = useState("")
  const entriesPerPage = 10
  const [downloadingFunctionalGroupsExcel, setDownloadingFunctionalGroupsExcel] = useState(false)

  const getFunctionalGroups = (page = null) => {
    setFetchingFunctionalGroups(true)
    page = page || 1
    setCurrentPage(page)

    axios.get(`${getServerURL()}functional-groups/?is_active=true`, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` },
      params: {
        "ordering": "name",
        "name": searchTerm,
        "limit": entriesPerPage,
        "offset": entriesPerPage * (page - 1)
      }
    }).then(response => {
      setFunctionalGroups(response.data.results)
      setNumberOfPages(Math.ceil(response.data.count / entriesPerPage))
    }).catch(error => {
      handleErrorFetchingData(error)
    }).finally(() => {
      setFetchingFunctionalGroups(false)
    })
  }

  const exportFunctionalGroupUsers = () => {
    setDownloadingFunctionalGroupsExcel(true);
    axios.get(`${getServerURL()}export-functional-group-users/`, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` },
      responseType: 'blob'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const date = new Date().toJSON().split("T")[0].split('-')
      const formattedDate = `${date[1]}-${date[2]}-${date[0]}`
      link.setAttribute('download', `Users of All Functional Groups_${formattedDate}.xlsx`)
      swal({
        title: "Your file is ready",
        text: "Click the button to download",
        icon: "success",
        button: 'Download'
      })
      .then(() => {
        document.body.appendChild(link)
        link.click()
      })
    }).catch(error => {
      console.log(error.response)
    }).finally(() => {
      setDownloadingFunctionalGroupsExcel(false);
    })
  };

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      getFunctionalGroups()
    }
  }

  useEffect(() => {
    getFunctionalGroups()
  }, [])

  return (
    <div id="TrainingContainer">
      <Grid>
      <Row>
      <Col xs={12} sm={12} md={12} lg={12}>
      <div>
        <h5>
          Search
        </h5>
        <FormGroup>
          <InputGroup>
            <FormControl
              disabled={ fetchingFunctionalGroups }
              value={ searchTerm }
              onChange={ (e) => setSearchTerm(e.target.value)}
              onKeyDown={ handleEnterPress }
              placeholder="Functional Group Name"
            />
            <InputGroup.Button>
              <Button
                bsStyle="default"
                onClick={ getFunctionalGroups }
              >
                <Glyphicon glyph="search" />
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
      </div>
      <div>
        <CreateEditFunctionalGroupModal getFunctionalGroups={ getFunctionalGroups } />
        <Button className="pull-right"
          disabled={downloadingFunctionalGroupsExcel}
          onClick={exportFunctionalGroupUsers}
        >
          {downloadingFunctionalGroupsExcel ?
            <Glyphicon
              glyph='refresh'
              style={{minWidth: '170px'}}
              className='rotate-btn'
            />
            :
            'Export All Groups and Users to Excel'
          }
        </Button>
      </div>
      { numberOfPages > 1 &&
        <center>
          <PaginationButtons
            onClick={ getFunctionalGroups }
            numberOfPages={ numberOfPages }
            currentPage={ currentPage }
            buttonsPerPage={ 5 }
          />
        </center>
      }
      { fetchingFunctionalGroups ?
        <LoadingAnimation />
        :
        <FunctionalGroupList functionalGroups={ functionalGroups } getFunctionalGroups={ getFunctionalGroups } />
      }
    </Col>
    </Row>
    </Grid>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/index.js